


































import {Component, Vue, Inject} from 'vue-property-decorator';
import FlexGridModel from '@/models/FlexGridModel';

@Component
export default class FlexGridHeaderSettingsDropdownMenu extends Vue {
    @Inject() moduleName!: string;

    get mainData(): FlexGridModel | null {
        return this.$store.state[this.moduleName].data;
    }

    get currentConfigText() {
        return this.mainData?.Config.Configs.find(config => config.Id === this.mainData?.Config.IdCurrentConfigItem)
            ?.Name;
    }
    get isEditConfigDisabled() {
        return !!this.mainData?.Config.Configs.find(
            (item: any) => item.Id === this.mainData?.Config.IdCurrentConfigItem && item.IsDefault,
        );
    }
    get transpose(): boolean {
        return this.$store.state[this.moduleName].transpose;
    }
}
